import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import { FaPencilAlt } from 'react-icons/fa';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import environment from '../../src/environments/environment';
import '../App.css';
import CancelModalComponent from '../popUpModals/CancelModalComponent';
import SubmitModalComponent from '../popUpModals/SubmitModalComponent';
import * as constants from '../Constants';
import { Loading } from 'react-loading-ui';

const mapStateToProps = (state) => {
    return {
        userStatus: state.lognReducer
    }
}

class UserSubmit extends React.Component {
    constructor() {
        super();
        this.state = {
            show: false,
            reDirect: '',
            pageSize: '',
            totalItems: '',
            //pager object
            pager: {},
            // paged items
            pagedItems: [],
            email: '',
            userRole: '',
            shows: false
        }
    }
    componentDidMount = async () => {
        if (this.props.userStatus.userName !== "") {
            this.setState({
                pageSize: this.toSetPagination(),
                email: this.props.userStatus.emailId,
                userRole: this.props.userStatus.userRole,
            }, () => {
                this.setPage(1);
            })

        } else {
            this.setState({
                reDirect: '/',
            })
        }

    }

    changeValue = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    search = e => {
        e.preventDefault();
        this.setPage(1);
    }


    toSetPagination() {
        let pageSize = 0;
        if (localStorage.getItem("listingPageSize") != null &&
            localStorage.getItem("listingPageSize") !== undefined && localStorage.getItem("listingPageSize") !== '0') {
            let tempstr = localStorage.getItem("listingPageSize");
            pageSize = parseInt(tempstr);
        }
        else {
            pageSize = 5;
        }
        return pageSize;
    }

    onPageNoChanged = (pageNo) => {
        this.setPage(pageNo);
    }

    pageSizeChanged = (pageSize) => {
        this.setState({
            pageSize: pageSize
        }, () => {
            this.setPage(1);
            localStorage.setItem('listingPageSize', pageSize);
        })
    }

    setPage(page) {
        //this.getCaseInfoList(page, this.state.pageSize);
    }

    onCancelChanges() {
        this.setState({
            reDirect: './userSummary'
        })
    }

    onCloseModal() {
        this.setState({
            show: false
        })
    }

    onSubmitChanges() {        
        Loading();
        this.onCloseModal();
        let UserList = this.props.values.UsersList;
        axios.post(environment.saveUser, UserList).then(response => {
            if (response.data.apiResponseVO.type === constants.API_RESPONSE_TYPE_SUCCESS) {
                this.setState({
                    reDirect: './userSummary'
                })
                setTimeout(() => {
                    Loading();
                });
                toast.success(response.data.apiResponseVO.message,
                    { position: toast.POSITION.TOP_CENTER }
                )

            } else {
                setTimeout(() => {
                    Loading();
                });
                toast.error(response.data.apiResponseVO.message, { position: toast.POSITION.TOP_CENTER })
            }
        }).catch((error) => {
            setTimeout(() => {
                Loading();
            });
            toast.error(error.message, { position: toast.POSITION.TOP_CENTER })
        });
    }

    onSubmit() {
        this.setState({
            ...this.state,
            shows: true
        })
    }

    onSubmitModal() {
        this.setState({
            ...this.state,
            shows: false
        })
    }

    showModal = (event) => {
        event.preventDefault();
        this.setState({
            ...this.state,
            show: true
        })
    }

    onEdit(event) {
        event.preventDefault();
        if (this.props.values.update) {
            this.props.stepFour();
        } else {
            this.props.secondStep();
        }
    }

    render() {
        if (this.state.reDirect) {
            return <Redirect
                to={{
                    pathname: this.state.reDirect
                }} />
        }
        const { values, prevStep, secondStep } = this.props
        return (
            <section style={{ paddingLeft: '20px', paddingRight: '20px' }}>
                <div className="container mt-2 ">
                    <h4>Review & Submit</h4>
                    <hr></hr>
                    <div >
                        <h5>Selected Uers <FaPencilAlt className="mr-2" onClick={(event) => this.onEdit(event)}></FaPencilAlt></h5>
                        <div className="table-responsive dashboard ">
                            <table className="table table-bordered table-condensed table-striped table-hover table-sm"
                                id="table-dashboard">
                                <thead className="color">
                                    <tr style={{ borderStyle: 'hidden' }}>
                                        <th>Name</th>
                                        <th>Login Id</th>
                                        <th>User Type</th>
                                        <th>Source</th>
                                    </tr>
                                </thead>
                                <tbody style={{ borderStyle: 'hidden' }}  >
                                    {
                                        values.UsersList.map((user, index) => (
                                            <tr key={index}>
                                                <td>{user.firstName} {user.lastName}</td>
                                                <td>{user.mailId}</td>
                                                <td>Member</td>
                                                <td>Azure Active Directory</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <hr></hr>
                    <div>
                        <h5>Selected Role <FaPencilAlt className="mr-2" onClick={prevStep}></FaPencilAlt></h5>
                        <div className="Row">
                            <input type="radio" className="form-check-input" name="adminsRadios"
                                id="amoptionId" value="ADMIN"
                                defaultChecked={values.rolename === 'Admin' ? true : false} disabled /> <label
                                    className="form-check-label" for="amoptionId" >Admin </label>

                            <input type="radio" className="form-check-input" name="supervisor"
                                id="supervisorId" value="Supervisor" defaultChecked={values.rolename === 'Supervisor' ? true : false} disabled
                            /> <label
                                className="form-check-label" for="superviosorId">Superviosor </label>

                            <input type="radio" className="form-check-input" name="attorney"
                                id="attorneyId" value="Attorney" defaultChecked={values.rolename === 'Attorney' ? true : false}
                                disabled /> <label
                                    className="form-check-label" for="attorneyId">Attorney </label>
                        </div>
                        {values.rolename === 'Attorney' && <div className="Row">
                            <label><b>Superviosor :</b></label> {values.supervisor}
                        </div>}
                    </div>
                    <hr></hr>
                    <div className="row mb-2 mt-2">
                        <div className="col-md-6 mr-auto text-left">
                           <button onClick={prevStep} className="btn  btn-primary" style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} >Back</button>
                           <button className="btn  btn-primary " onClick={() => this.onSubmit()} style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} >Submit</button>
                             
                            <button onClick={this.showModal} className="btn  btn-primary " style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} >Cancel  </button>
                        </div>
                    </div >
                    <main>
                        <CancelModalComponent show={this.state.show} hideModal={() => this.onCloseModal()} cancelChanges={() => this.onCancelChanges()}></CancelModalComponent>
                        <SubmitModalComponent show={this.state.shows} hideModal={() => this.onSubmitModal()} submitChanges={() => this.onSubmitChanges()}></SubmitModalComponent>
                    </main>
                    <ToastContainer style={{ marginTop: '7%' }} />
                </div >
            </section >
        )
    }

}
export default connect(mapStateToProps)(UserSubmit);